import type { VacancyFiltersQuery } from '../types';

const POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;

export const getResponsibleUserVacancyFilter = (
  responsibleUserId: string | null
): VacancyFiltersQuery => {
  const normalizedId = responsibleUserId?.trim();

  if (!normalizedId || !POSITIVE_INTEGER_PATTERN.test(normalizedId)) {
    return {};
  }

  return {
    'responsibleUser.id': {
      items: [normalizedId],
      operator: 'or',
    },
  };
};
